import React from "react";
import Carousel from "./Carousel";

interface FeatureProps {
    images: string[];
    title: string;
    subtitle: string;
    description: string;
    imageRight?: boolean;
}

const Feature: React.FC<FeatureProps> = ({
    images,
    title,
    subtitle,
    description,
    imageRight = false,
}) => {
    return (
        <div className="flex flex-col lg:flex-row items-center lg:justify-between bg-white rounded-xl shadow-md p-8 md:p-12 mb-8">
            {/* Text Section */}
            <div
                className={`w-full lg:w-1/2 ${imageRight ? "lg:order-1" : "lg:order-none"
                    } flex flex-col items-center lg:items-start text-center lg:text-left`}
            >
                <h3 className="text-2xl font-semibold mb-2">{title}</h3>
                <h4 className="text-xl text-gray-700 mb-4">{subtitle}</h4>
                <p className="text-gray-600">{description}</p>
            </div>
            {/* Divider */}
            <div
                className={`
                    my-8 lg:my-0
                    w-full h-px bg-gray-200
                    lg:w-px lg:h-64 lg:bg-gray-200
                    ${!imageRight ? "lg:order-none" : "lg:order-1"}
                    lg:mx-8
                `}
                aria-hidden="true"
            />
            {/* Image Section */}
            <div
                className={`w-full lg:w-1/2 flex justify-center lg:justify-end mt-12 lg:mt-0 ${!imageRight ? "lg:ml-16" : "lg:mr-16"
                    }`}
            >
                {images.length > 1 ? (
                    <Carousel images={images} alt={title} timer={7} />
                ) : (
                    <img
                        src={images[0]}
                        alt={title}
                        className="rounded-lg object-contain max-h-72 lg:max-h-[400px] w-auto"
                    />
                )}
            </div>
        </div>
    );
};

export default Feature;